function fetch(client, slug) {
  return client.$get(`/categories/${slug}`)
}

export default {
  fetch: fetch
}